import React from 'react'
import { DashboardApi } from '../../../api/dashboard_api'
import { ProductApi } from '../../../api/product_api'
import { SalesPersonApi } from '../../../api/salespeopleApi'
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, LineChart, Line,
    PieChart, Pie
} from 'recharts';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import _ from "lodash";

const paperStyle = {
    marginTop: 20,
    paddingBottom: 10,
    paddingTop: 25,
    padingLeft: -50,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};

const cardStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const COLOR_PALLETE = ["#264653",
    "#2a9d8f",
    "#e9c46a",
    "#f4a261",
    "#e76f51",
    "#3d405b",
    "#a8dadc",
    "#457b9d",
    "#1d3557"
];

export class SalesDashboardView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            salespersonBarchar: null,
            monthlyLineChart: {},
            productTypeStackedChart: null,
            currentMonthTotal: 0,
            todayTotal: 0,
            yesterdayTotal: 0,
            isLoading: true,
            productTypeNames: null,
            payrollNames: null,
            todayBuys: 0,
            pieChart: [],
            monthTotal: null,
            prevMonthTotal: null,
            todayBuysMonth: 0,
        }
    }

    componentWillMount = () => {
        SalesPersonApi.getSalesPayroll()
            .then(response => {
                this.setState({ payrollNames: response.data.map(item => item.username) })
            })
        ProductApi.getProductTypes()
            .then(response => {
                this.setState({ productTypeNames: response.data.map(item => item.name) })
                this.getDashboard()
            }).catch(error => {
                console.log(error)
            })

    }
    getDashboard = () => {
        DashboardApi.getDashboard()
            .then(response => {
               
                this.setState({
                    salespersonBarchar: response.data.salesperson_monthly,
                    productTypeStackedChart: response.data.prod_type_monthly,
                    monthlyLineChart: response.data.monthly_sales,
                    yesterdayTotal: response.data.yesterday_total,
                    todayTotal: response.data.today_total,
                    todayBuys: response.data.today_buys.total,
                    todayBuysMonth: response.data.total_buys_month,
                    monthTotal: response.data.current_month_total,
                    prevMonthTotal: response.data.previous_month_total,
                    pieChartPayMethod: [{ name: 'Credito', value: response.data.today_buys.credit },
                    { name: 'Debito', value: response.data.today_buys.debit },
                    { name: 'Efectivo', value: response.data.today_buys.cash }],
                    pieChartProductTypes: response.data.today_buys.product_types,
                    isLoading: false
                })

            })
            .catch(error => {
                console.log(error)
            })
    }

    calculateDateDiff = () => {
        if (parseFloat(this.state.todayTotal) == 0 && parseFloat(this.state.yesterdayTotal) == 0) {
            return 0
        }
        else if (parseFloat(this.state.todayTotal) == 0) {
            return -100
        }
        else if (parseFloat(this.state.yesterdayTotal) == 0) {
            return +100
        }
        else {
            return _.round(((this.state.todayTotal * 100) / this.state.yesterdayTotal), 2)

        }
    }
    calculateMonthDiff = () => {
        if (parseFloat(this.state.monthTotal) == 0 && parseFloat(this.state.prevMonthTotal) == 0) {
            return 0
        }
        else if (parseFloat(this.state.monthTotal) == 0) {
            return -100
        }
        else if (parseFloat(this.state.prevMonthTotal) == 0) {
            return +100
        }
        else {
            return _.round(((this.state.monthTotal * 100) / this.state.prevMonthTotal), 2)

        }
    }

    
    loadDashboard = () => {
        const isPieChart = this.state.pieChartPayMethod.map(item => item.value > 0).every(Boolean)
        return <div style={{ marginLeft: 0, marginTop: isPieChart ? 30 : -110 }}>
            <BarChart
                width={1000}
                height={400}
                data={this.state.salespersonBarchar}
            >
                <CartesianGrid strokeDasharray="4 4" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend layout="horizontal" verticalAlign="top" align="center" />

                {this.state.payrollNames && this.state.payrollNames.map((name, k) => {
                    return <Bar dataKey={name} fill={COLOR_PALLETE[k]} />
                })}
            </BarChart>
            <br />
            <br />
            <div style={{ marginTop: 30 }}>
                <AreaChart
                    width={1000}
                    height={400}
                    top={5}
                    bottom={10}
                    data={this.state.productTypeStackedChart}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    {this.state.productTypeNames.map((item, k) => {
                        return <Area type="monotone" dataKey={item} stackId="1" stroke="#8884d8" fill={COLOR_PALLETE[k]} />
                    })}
                </AreaChart>
            </div>
            <br />
            <br />
            <LineChart
                width={1000}
                height={400}
                data={this.state.monthlyLineChart}

            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey='total' stroke="#264653" activeDot={{ r: 8 }} />
            </LineChart>
        </div >
    }
    render() {
        return (
            <div>
                <div class='col-md-12' style={{ marginLeft: -20}}>
                    <div class='col-md-1' />
                    <div class='col-md-3'  style={{marginTop: 20 }}>
                        <Card className={cardStyles.root}>
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    Total hoy
                                </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    <NumberFormat
                                        value={this.state.todayTotal}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>
                                <Typography
                                    style={{ marginTop: 10, textAlign: 'center', color: this.state.todayTotal >= this.state.yesterdayTotal ? "green" : "red" }}

                                >
                                    {!this.state.isLoading && this.calculateDateDiff()} %
                        </Typography>
                                <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', marginBottom: -15 }}>
                                    {this.state.todayTotal >= this.state.yesterdayTotal ? "Mayor que ayer" : "Menor que ayer"}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                    <div class='col-md-1' />
                    <div class='col-md-3' style={{ marginTop: 20 }}>
                        <Card className={cardStyles.root}>
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    Total ayer
                        </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    <NumberFormat
                                        value={this.state.yesterdayTotal}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>

                            </CardContent>
                        </Card>
                    </div>
                    <div class='col-md-1' />
                    <div class='col-md-2' style={{ marginTop: 20 }}>
                        <Card className={cardStyles.root} >
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    N ventas hoy
                        </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    {this.state.todayBuys}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div class='col-md-12' style={{ marginLeft: -20}}>
                    <div class='col-md-1' />
                    <div class='col-md-3' style={{marginTop: 20 }}>
                        <Card className={cardStyles.root}>
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    Total mes actual
                                </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    <NumberFormat
                                        value={this.state.monthTotal}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>
                                <Typography
                                    style={{ marginTop: 10, textAlign: 'center', color: this.state.monthTotal >= this.state.prevMonthTotal ? "green" : "red" }}

                                >
                                    {!this.state.isLoading && this.calculateMonthDiff()} %
                        </Typography>
                                <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', marginBottom: -15 }}>
                                    {this.state.monthTotal >= this.state.prevMonthTotal ? "Mayor  al mes previo": "Menor al mes previo"}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                    <div class='col-md-1' />
                    <div class='col-md-3' style={{ marginTop: 20 }}>
                        <Card className={cardStyles.root}>
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    Total mes anterior
                        </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    <NumberFormat
                                        value={this.state.prevMonthTotal}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>

                            </CardContent>
                        </Card>
                    </div>
                    <div class='col-md-1' />
                    <div class='col-md-2' style={{marginTop: 20 }}>
                        <Card className={cardStyles.root} >
                            <CardContent>
                                <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                    N ventas mes
                        </Typography>
                                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                    {this.state.todayBuysMonth}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div class='col-md-12' >
                    {!this.state.isLoading && <div style={{ marginLeft: 120, borderColor: 'red' }}>
                        <PieChart width={850} height={400}>
                            <Pie isAnimationActive={false} data={this.state.pieChartPayMethod} cx={150} cy={150} outerRadius={70} fill="grey" label />
                            <p>Total de ventas por forma de pago</p>
                            <Pie isAnimationActive={false} data={this.state.pieChartProductTypes} cx={550} cy={150} outerRadius={70} fill="grey" label />
                            <p>Total de productos vendidos por tipo</p>
                            <Tooltip />
                        </PieChart>
                    </div>}
                </div>
                {this.state.isLoading &&
                    <div style={{ marginTop: 100 }} className="col-md-10 col-md-offset-1">
                        <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{ display: 'center' }} />
                    </div>
                }
                {!this.state.isLoading && <div class='col-md-12' style={{ marginTop: 0 }}>
                    {this.loadDashboard()}</div>}

            </div>


        )
    }
}

export default SalesDashboardView


// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard/SalesDashboardView.js